var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgComment = function SvgComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    className: "comment_svg__design-iconfont"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 13h14.334a2.487 2.487 0 0 1 2.487 2.487v8.818a2.487 2.487 0 0 1-2.487 2.487H15.258a.829.829 0 0 0-.475.149l-2.253 1.575a1.569 1.569 0 0 1-2.467-1.286V15.487A2.487 2.487 0 0 1 12.55 13Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
};
export default SvgComment;